import {
  useListActiveEscortFeesByCongressIdQuery,
  useListEscortFeesByCongressIdQuery,
} from "../store/fee/fee";
import { Fee } from "../types/fee.types";

interface UseEscortFeesQueryResult {
  fees: Fee[];
  areFeesLoading: boolean;
}

export const useEscortFeesQuery = (
  congressId: number,
  isEditMode: boolean
): UseEscortFeesQueryResult => {
  const feesPublicQuery = useListActiveEscortFeesByCongressIdQuery(congressId, {
    skip: isEditMode,
  });
  const feesHiddenQuery = useListEscortFeesByCongressIdQuery(congressId, {
    skip: !isEditMode,
  });

  const fees = isEditMode
    ? feesHiddenQuery.data ?? []
    : feesPublicQuery.data ?? [];
  const areFeesLoading = isEditMode
    ? feesHiddenQuery.isLoading
    : feesPublicQuery.isLoading;

  return {
    fees,
    areFeesLoading,
  };
};
